let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6iPPM")).then(() => parcelRequire('iC5DO'));